import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { FilterDisplayContainer } from 'components/FilterDisplayContainer/FilterDisplayContainer';
import { filterMessages } from 'components/Filters/filterMessages';
import { PriceFilter } from 'components/Filters/PriceFilter/PriceFilter';
import { useFiltersForm } from 'hooks/useFiltersForm';
import { getCurrencyCode, getLocalTaxesIncluded, getTaxesIncluded } from 'modules/meta/selectors';
import { searchParamToFacet } from 'modules/search/constants';
import { prop } from 'ramda';
import Settings from 'Settings';
import { getEnabledCurrencies } from '@daedalus/core/src/localization/business/currency';
const filterKeys = [searchParamToFacet.priceMin.param, searchParamToFacet.priceMax.param];
const PriceFilterWrapper = /*#__PURE__*/styled('div')({
  name: "PriceFilterWrapper",
  class: "pzduw6d",
  propsAsIs: false
});
const ActiveLabel = /*#__PURE__*/styled('span')({
  name: "ActiveLabel",
  class: "a1pe715i",
  propsAsIs: false
});
interface Props {
  isActive?: boolean;
}
export const PriceFilterPopover: React.FC<Props> = ({
  isActive = false
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    submitFilters,
    getFilters,
    getAppliedFilters,
    toggleFilters,
    clearFilters,
    resetFilters,
    trackFilterClick,
    getPriceActiveLabel
  } = useFiltersForm(filterKeys, 'price');
  const taxesAreIncluded = useSelector(getTaxesIncluded);
  const localTaxesAreIncluded = useSelector(getLocalTaxesIncluded);
  const includeTaxes = taxesAreIncluded || localTaxesAreIncluded;
  const currencyCode = useSelector(getCurrencyCode);
  const enabledCurrencies = getEnabledCurrencies(Settings.get('ENABLED_CURRENCIES'));
  const currency = enabledCurrencies.find(currency => currency.code === currencyCode);
  const currencySymbol = prop('symbol', currency);
  const {
    priceMin,
    priceMax
  } = getFilters();
  const {
    priceMin: appliedPriceMin,
    priceMax: appliedPriceMax
  } = getAppliedFilters();
  return <FilterDisplayContainer label={isActive ? <ActiveLabel>
            {getPriceActiveLabel({
      minPrice: appliedPriceMin,
      maxPrice: appliedPriceMax,
      currencySymbol
    })}
          </ActiveLabel> : formatMessage(filterMessages.priceFilter)} dataId="priceFilter" title={formatMessage(filterMessages.nightlyPrice)} subtitle={includeTaxes && formatMessage(filterMessages.priceSubtitle)} isActive={isActive} onClear={clearFilters} onApply={submitFilters} onClose={resetFilters} onPillClick={trackFilterClick}>
      <PriceFilterWrapper>
        <PriceFilter priceMin={priceMin} priceMax={priceMax} onChange={toggleFilters} />
      </PriceFilterWrapper>
    </FilterDisplayContainer>;
};

require("./PriceFilterPopover.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PriceFilterPopover.tsx");